/**
 * Stripe billing service for React app.
 * Replaces the original code that used Stripe SDK + assets/data.
 * Calls backend stripe routes only; no Stripe SDK or secret keys in the app.
 * Pricing: monthlyPrices / monthlyPricesTest – test vs prod chosen by env.
 *
 * Env: REACT_APP_API_URL or REACT_APP_STRIPE_API_URL (backend).
 *      REACT_APP_STRIPE_USE_TEST_PRICES=true to use monthlyPricesTest.
 *
 */

import { monthlyPrices, monthlyPricesTest } from '../assets/data';

// Test and prod have different prices
const useTestPrices =
  process.env.REACT_APP_STRIPE_USE_TEST_PRICES === 'true' ||
  (process.env.REACT_APP_STRIPE_API_URL || process.env.REACT_APP_API_URL || '').toLowerCase().includes('test');

const PRICES = useTestPrices ? monthlyPricesTest : monthlyPrices;

const getBaseUrl = () =>
  process.env.REACT_APP_STRIPE_API_URL || process.env.REACT_APP_API_URL || '';

async function request(path, options = {}) {
  const base = getBaseUrl().replace(/\/$/, '');
  const url = `${base}${path}`;
  const res = await fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(process.env.REACT_APP_API_AUTHORIZATION && {
        Authorization: process.env.REACT_APP_API_AUTHORIZATION,
      }),
      ...options.headers,
    },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.message || data.error || res.statusText);
    err.status = res.status;
    err.response = data;
    throw err;
  }
  return data;
}

/**
 * Get invoices for a Stripe customer.
 * @param {string} stripeId - Stripe customer ID (e.g. cus_xxx)
 * @param {string} status - Invoice status: draft, open, paid, uncollectible, void
 * @returns {Promise<Array<{invoiceNumber, customerName, createdAt, totalAmount, invoiceStatus, url}>>}
 */
export async function getUserInvoices(stripeId, status) {
  const params = new URLSearchParams({ stripe_id: stripeId, status });
  return request(`/stripe/invoices?${params}`);
}

/**
 * Get when the last monthly bill was run (value from database).
 * @returns {Promise<{ last_run_month: string } | null>} e.g. { last_run_month: "2025-01" } or null
 */
export async function getLastMonthlyBill() {
  return request('/stripe/last-monthly-bill');
}

/**
 * Send monthly bills for organizations.
 * Price is resolved from PRICES[organization.tier][organization.type] (same as original code).
 * You can also pass price directly on each org to override.
 * @param {Array<{stripeId: string, tier: string, type: string, totalMonthlyCalls: number, price?: string}>} monthlyOrgs
 * @returns {Promise<{success: boolean, message: string}>}
 */
export async function sendMonthlyBill(monthlyOrgs) {
  const organizations = monthlyOrgs.map((org) => {
    const price = org.price ?? (PRICES[org.tier] && PRICES[org.tier][org.type] ? PRICES[org.tier][org.type] : null);
    if (!price) {
      throw new Error(`No price for organization ${org.stripeId} (tier: ${org.tier}, type: ${org.type}). Check data.js.`);
    }
    return {
      stripeId: org.stripeId,
      price,
      totalMonthlyCalls: org.totalMonthlyCalls,
    };
  });

  return request('/stripe/monthly-bill', {
    method: 'POST',
    body: JSON.stringify({ organizations }),
  });
}

// import { monthlyPrices, monthlyPricesTest } from '../assets/data';
// const stripe = require('stripe')(process.env.REACT_APP_STRIPE_API);

// let PRICES = {}
// // test and prod have differnt prices
// if (process.env.REACT_APP_STRIPE_API.includes("test")){
//   PRICES = monthlyPricesTest
// } else {
//   PRICES = monthlyPrices
// }


// //const invoiceList = async (stripeId, status) =>{
// export const getUserInvoices = async (stripeId, status) =>{
//   let invoiceData = []
//   const invoices = await stripe.invoices.list({
//       customer: stripeId,
//       status: status,
//     });

//   invoices.data.forEach((data) => {
//     invoiceData.push({invoiceNumber: data.number, customerName: data.customer_name, createdAt: data.created, 
//       totalAmount: data.total, invoiceStatus: data.status, url: data.hosted_invoice_url})
//   });

//   return invoiceData;
// }


// //recieves all monthly organizations along with the num of calls, 
// export const sendMonthlyBill = async(monthlyOrgs) => {
//   try {
//     // Use Promise.all to wait for all invoices to be created
//     await Promise.all(monthlyOrgs.map(async(organization) => {
//       try {
//         const organizationInvoice = await stripe.invoices.create({
//           customer: organization.stripeId,
//           collection_method: 'charge_automatically',
//           auto_advance: true,
//           automatic_tax: {enabled: true},
//         });

//         await stripe.invoiceItems.create({ 
//           customer: organization.stripeId,
//           price: PRICES[organization.tier][organization.type],
//           invoice: organizationInvoice.id,
//           quantity: organization.totalMonthlyCalls,
//         });
//       } catch (error) {
//         console.error(`Error creating invoice for organization ${organization.stripeId}:`, error);
//         throw error;
//       }
//     }));
//     return { success: true, message: 'Monthly bills sent successfully' };
//   } catch (error) {
//     console.error('Error sending monthly bills:', error);
//     return { success: false, message: error.message };
//   }
// }
